<script setup lang="ts">
defineProps<{
  step: number;
  /** Titre simple ; le slot `title` le remplace quand il faut du balisage. */
  title?: string;
  text?: string;
}>();
</script>

<template>
  <li class="d-flex gap-3">
    <span class="step-number flex-shrink-0">{{ step }}</span>
    <div class="d-flex flex-column gap-1">
      <strong
        ><slot name="title">{{ title }}</slot></strong
      >
      <span v-if="text" class="step-text">{{ text }}</span>
      <slot />
    </div>
  </li>
</template>

<style lang="scss" scoped>
.step-number {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.75rem;
  height: 1.75rem;
  border-radius: 50%;
  background-color: var(--bs-primary);
  color: white;
  font-size: 0.85rem;
  font-weight: 700;
}

.step-text {
  font-size: 0.875rem;
  color: var(--bs-secondary-color);
}
</style>
